module.exports = __webpack_public_path__ + "media/images/resource/ezCater_Logo_green-1596b0967234b6c068a3c2b7edb07115.png";